export default __webpack_public_path__ + "1e5f1c42ec4efcece84a83b273e259c8.png";